import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import FormCarrossel from '../../FormCarrossel/CarroselGestaoRisco';
import InfoComponent from '../InfoComponent';

class GuestaoDeRiscaoPage extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}

				<main>
					<ErrorBoundary><Header /></ErrorBoundary>

					<InfoComponent image={"guestaoderisco"} page={'guestaoderisco'}></InfoComponent>

					<div className="_the-content page-planos page-gestaoderisco py-10">
						<div id='politica' className='container'>
							<div className="row justify-content-center">
								<div className="col-md-10">
									<h3 > Política de Gestão de Riscos </h3>
									<p>
										Documento de 1º Nível do Sistema de Gestão de Riscos da Forluz, aprovado pelo Conselho Deliberativo da Fundação em 17/11/2016, conforme CRCD nº 020/2016.
									</p>

									<br />

									<h4> Para realizar download do(s) arquivo(s) clique no(s) link(s) abaixo: </h4><br />
									<div style={{ position: "relative", left: "-10%" }}> <ErrorBoundary><FormCarrossel page={"ObterGestaoRiscoPolitica"} /></ErrorBoundary></div>
									<br />
								</div>
							</div>
						</div>
						<div id='plano' className="py-10">
							<div className='container'>
								<div className='row justify-content-center'>
									<div className='col-md-10'>
										<h3 > Plano de Gestão de Riscos </h3>
										<p>
											Documento de 2º Nível do Sistema de Gestão de Riscos da Forluz, aprovado pelo Conselho Deliberativo da Fundação em 17/11/2016, conforme CRCD nº 020/2016.
										</p>

										<br />

										<h4> Para realizar download do(s) arquivo(s) clique no(s) link(s) abaixo: </h4><br />
										<br />
										<div style={{ position: "relative", left: "-10%" }}>
											<ErrorBoundary><FormCarrossel page={"ObterGestaoPlano"} /></ErrorBoundary>
										</div>

									</div>

								</div>
							</div>
						</div>

						<div id='docs' className="bg-white py-10">
							<div className='container'>
								<div className='row justify-content-center'>
									<div className='col-md-10'>
										<h3  > Gestão de Riscos - Demais documentos </h3>

										<br />
										<h4> Documentos de 4º Nível </h4>

										<p>
											Documentos referentes a procedimentos do Sistema de Gestão de Riscos da Forluz. Foram aprovados pela Diretoria Executiva da Fundação em 14/10/2016, conforme PRD nº 052/2016 e submetidos a posterior aprovação do Conselho Deliberativo, em 17/11/2016, conforme CRCD nº 020/2016.
										</p>
										<div style={{ position: "relative", left: "-10%" }}>
											<ErrorBoundary><FormCarrossel page={"ObterGestaoRiscoDemaisDocs"} subgroup={"Documentos de 4 Nível"} /></ErrorBoundary>
										</div>
										<h4> Documentos de 3º Nível </h4>

										<p>
											Documentos referentes a planos e definições de contextos do Sistema de Gestão de Riscos da Forluz. Foram aprovados pela Diretoria Executiva da Fundação em 14/10/2016, conforme PRD nº 052/2016 e submetidos a posterior aprovação do Conselho Deliberativo, em 17/11/2016, conforme CRCD nº 020/2016.
										</p>
										<div style={{ position: "relative", left: "-10%" }}>
											<ErrorBoundary><FormCarrossel page={"ObterGestaoRiscoDemaisDocs"} subgroup={"Documentos de 3 Nível"} /></ErrorBoundary>
										</div>

									</div>
								</div>
							</div>
						</div>


						<div id='indicadores' className="bg-white py-10">
							<div className='container'>
								<div className='row justify-content-center'>
									<div className='col-md-10'>
										<h3  > Gestão de Riscos - Indicadores </h3>
										<br />
										<h4> Plano A </h4>
										<p>
											Indicadores de risco apropriados a cada categoria considerada em seu SGR, utilizados no processo de monitoramento dos riscos do Plano A.
										</p>
										<div style={{ position: "relative", left: "-10%" }}><ErrorBoundary><FormCarrossel page={"ObterGestaoRiscoIndicadores"} subgroup={"Indicadores Plano A"} /></ErrorBoundary>
										</div>
										<h4> Plano B </h4>

										<p>
											Indicadores de risco apropriados a cada categoria considerada em seu SGR, utilizados no processo de monitoramento dos riscos do Plano B.
										</p>
										<div style={{ position: "relative", left: "-10%" }}><ErrorBoundary><FormCarrossel page={"ObterGestaoRiscoIndicadores"} subgroup={"Indicadores Plano B"} /></ErrorBoundary>
										</div>


										<h4> Taesaprev </h4>

										<p>
											Indicadores de risco apropriados a cada categoria considerada em seu SGR, utilizados no processo de monitoramento dos riscos do Taesaprev.
										</p>
										<div>
											<div style={{ position: "relative", left: "-10%" }}>

												<ErrorBoundary><FormCarrossel page={"ObterGestaoRiscoIndicadores"} subgroup={"Indicadores TaesaPrev"} /></ErrorBoundary>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* Content page */}

				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>

		);
	}
};

export default GuestaoDeRiscaoPage;